import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esKap } from "@/pages/es/esConditionData4";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/ketamine-assisted-psychotherapy-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esKap),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esKap} />;
}
